const actions = {
  PRODUCT_TYPE_BEGIN: "PRODUCT_TYPE_BEGIN",
  PRODUCT_TYPE_SUCCESS: "PRODUCT_TYPE_SUCCESS",
  PRODUCT_TYPE_ERR: "PRODUCT_TYPE_ERR",

  MODEL_BEGIN: "MODEL_BEGIN",
  MODEL_SUCCESS: "MODEL_SUCCESS",
  MODEL_ERR: "MODEL_ERR",

  EMPLOYEE_DETAIL_BEGIN: "EMPLOYEE_DETAIL_BEGIN",
  EMPLOYEE_DETAIL_SUCCESS: "EMPLOYEE_DETAIL_SUCCESS",
  EMPLOYEE_DETAIL_ERR: "EMPLOYEE_DETAIL_ERR",
  EMPLOYEE_DETAIL_RESET: "EMPLOYEE_DETAIL_RESET",

  EXCHANGE_MODEL_BEGIN: "EXCHANGE_MODEL_BEGIN",
  EXCHANGE_MODEL_SUCCESS: "EXCHANGE_MODEL_SUCCESS",
  EXCHANGE_MODEL_ERR: "EXCHANGE_MODEL_ERR",

  EMPLOYEE_BASED_STORE_LIST_BEGIN: "EMPLOYEE_BASED_STORE_LIST_BEGIN",
  EMPLOYEE_BASED_STORE_LIST_SUCCESS: "EMPLOYEE_BASED_STORE_LIST_SUCCESS",
  EMPLOYEE_BASED_STORE_LIST_ERR: "EMPLOYEE_BASED_STORE_LIST_ERR",

  BRAND_BEGIN: "BRAND_BEGIN",
  BRAND_SUCCESS: "BRAND_SUCCESS",
  BRAND_ERR: "BRAND_ERR",

  getProductTypeBegin: () => ({
    type: actions.PRODUCT_TYPE_BEGIN,
  }),

  getProductTypeSuccess: (data) => ({
    type: actions.PRODUCT_TYPE_SUCCESS,
    data,
  }),

  getProductTypeErr: (err) => ({
    type: actions.PRODUCT_TYPE_ERR,
    err,
  }),

  getModelBegin: () => ({
    type: actions.MODEL_BEGIN,
  }),

  getModelSuccess: (data) => ({
    type: actions.MODEL_SUCCESS,
    data,
  }),

  getModelErr: (err) => ({
    type: actions.MODEL_ERR,
    err,
  }),

  getEmployeeDetailBegin: () => ({
    type: actions.EMPLOYEE_DETAIL_BEGIN,
  }),

  getEmployeeDetailSuccess: (data) => ({
    type: actions.EMPLOYEE_DETAIL_SUCCESS,
    data,
  }),

  getEmployeeDetailErr: (err) => ({
    type: actions.EMPLOYEE_DETAIL_ERR,
    err,
  }),

  getEmployeeDetailDataReset: () => ({
    type: actions.EMPLOYEE_DETAIL_RESET,
  }),

  getExchangeModelBegin: () => ({
    type: actions.EXCHANGE_MODEL_BEGIN,
  }),

  getExchangeModelSuccess: (data) => ({
    type: actions.EXCHANGE_MODEL_SUCCESS,
    data,
  }),

  getExchangeModelErr: (err) => ({
    type: actions.EXCHANGE_MODEL_ERR,
    err,
  }),

  getEmployeeBasedStoreListBegin: () => ({
    type: actions.EMPLOYEE_BASED_STORE_LIST_BEGIN,
  }),

  getEmployeeBasedStoreListSuccess: (data) => ({
    type: actions.EMPLOYEE_BASED_STORE_LIST_SUCCESS,
    data,
  }),

  getEmployeeBasedStoreListErr: (err) => ({
    type: actions.EMPLOYEE_BASED_STORE_LIST_ERR,
    err,
  }),

  getBrandBegin: () => ({
    type: actions.BRAND_BEGIN,
  }),

  getBrandSuccess: (data) => ({
    type: actions.BRAND_SUCCESS,
    data,
  }),

  getBrandErr: (err) => ({
    type: actions.BRAND_ERR,
    err,
  }),
};

export default actions;
